import './App.css';

import Router from './Routes/Router';
function App() {
  return (
    <div >
      <header className="header">
        Notes App
      </header>
      <main>
       <Router/>
      </main>
    </div>
  );
}

export default App;
